module.exports = __webpack_public_path__ + "static/trees-fg-c42d75c3827e1952496493025a6fe944.svg";